$(document).ready(function () {
  $('.featured-product-slider').slick({
    arrows: true,
    infinite: true,
    dots: false,
    autoplay: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.reviews-slider').slick({
    arrows: true,
    infinite: true,
    dots: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.products-slider-section .product-slider').slick('refresh');
  
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  
  $('.products-slider-section .product-slider').slick('refresh');
  
});

$(".jdgm-preview-badge").click(function(e) {
//$(document).on('click','.jdgm-preview-badge', function (e) {
    e.preventDefault();
  console.log('hello');
    $('.tab-container ul li:nth-child(2)').trigger('click');
    $('html, body').animate({
        scrollTop: $(".tab-container").offset().top
    }, 2000);
});

$(document).on('click','.select-label', function () {
    if($(this).parent().hasClass('active')){
      $(this).parent().removeClass('active');
    }else{
      $('.dropdown').removeClass('active');
      $(this).parent().addClass('active');
    }
});
$(document).on('click','.dropdown-list li', function () {
    $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
    $(this).parents('.dropdown').removeClass('active');
    var variant_id = $(this).data('value');
    $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
});